import {
  loadMarketIntelligenceMock,
  MARKET_INTELLIGENCE_USE_MOCK_DATA,
  MarketplaceIntelligenceBaseApiClient
} from '../marketplace-intelligence/client';
import type { ProductDefinition } from '@interfaces/Study.interface';

function stringList(value: unknown): string[] | undefined {
  return Array.isArray(value) ? value.map(String) : undefined;
}

function mapProduct(item: unknown, fallbackId?: string): ProductDefinition {
  if (typeof item === 'string') {
    return {
      id: item,
      name: item,
      display_name: item,
      brands: [],
      aggregator: 'gocompare',
      product_key: item
    };
  }
  const obj = (item && typeof item === 'object' ? item : {}) as Record<
    string,
    unknown
  >;
  const id = String(obj.id ?? obj.name ?? obj.product ?? fallbackId ?? '');
  const productKey = String(obj.product_key ?? obj.product ?? id);
  return {
    id,
    name: String(obj.name ?? id),
    display_name: String(obj.display_name ?? obj.name ?? id),
    description: obj.description ? String(obj.description) : undefined,
    brands: stringList(obj.brands) ?? [],
    aggregator: obj.aggregator ? String(obj.aggregator) : 'gocompare',
    product_key: productKey,
    base_url: obj.base_url ? String(obj.base_url) : undefined,
    aggregator_brands: stringList(obj.aggregator_brands),
    direct_brands: stringList(obj.direct_brands),
    panel_only_brands: stringList(obj.panel_only_brands)
  };
}

export class ApiMarketplaceIntelligenceProducts extends MarketplaceIntelligenceBaseApiClient {
  async list(): Promise<ProductDefinition[]> {
    if (MARKET_INTELLIGENCE_USE_MOCK_DATA) {
      const mock = await loadMarketIntelligenceMock();
      return mock.listMockProducts();
    }
    const raw = await this.get<unknown>('/api/v1/products');
    if (Array.isArray(raw)) {
      return raw.map((item) => mapProduct(item));
    }
    if (raw && typeof raw === 'object') {
      return Object.entries(raw as Record<string, unknown>).map(([id, v]) =>
        mapProduct(v, id)
      );
    }
    return [];
  }
}

export { marketplaceIntelligenceProductsQueryKeys } from './query-keys';
export * from './use-marketplace-intelligence-products-queries';
export { ApiMarketplaceIntelligenceProducts as MarketplaceIntelligenceProductsApi };
